
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosPrestacaoContasMensal {
    codigo: string
    ano: string
    mes: string
    tipoPrestacao: string
    tipoEntrega: string
    situacao: string

    constructor() {
        this.codigo = ''
        this.ano = ''
        this.mes = ''
        this.tipoPrestacao = ''
        this.tipoEntrega = ''
        this.situacao = ''
    }

    limpar(): void {
        this.codigo = ''
        this.ano = ''
        this.mes = ''
        this.tipoPrestacao = ''
        this.tipoEntrega = ''
        this.situacao = ''
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.ano)
            data.append("exercicio", this.ano)
        if (this.mes)
            data.append("mes", this.mes)
        if (this.tipoPrestacao)
            data.append("tipoPrestacao", this.tipoPrestacao)
        if (this.tipoEntrega)
            data.append("tipoEntrega", this.tipoEntrega)
        if (this.codigo)
            data.append("idPcm", this.codigo)
        if (this.situacao)
            data.append("situacao", this.situacao)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.ano)
            retorno += '&exercicio=' + this.ano
        if (this.mes)
            retorno += '&mes=' + this.mes
        if (this.tipoPrestacao)
            retorno += '&tipoPrestacao=' + this.tipoPrestacao
        if (this.tipoEntrega)
            retorno += '&tipoEntrega=' + this.tipoEntrega
        if (this.codigo)
            retorno += '&idPcm=' + this.codigo
        if (this.situacao)
            retorno += '&situacao=' + this.situacao
        return retorno
    }
}